@if (isLoading) {
  <div class="loading-state">
    <p>Loading...</p>
  </div>
} @else {
  @if (data?.length) {
    @for (info of data; track info) {
      <div class="info-content">
        <div class="heading">
          <label>{{info.propertyName}}</label>
        </div>
        <div class="value">
          <p class="info">{{info.propertyValue}}</p>
          @if (info.subPropertyValue) {
            <p class="info">{{info.subPropertyValue}}</p>
          }
          <p class="info-sub">{{info.convictionDate}}</p>
          <p class="info-sub">{{info.stateOfViolation}}</p>
          <p class="info-sub">{{info.penalty}}</p>
          <p class="info-sub">{{info.demeritPoints}}</p>
          <div class="line"></div>
        </div>
      </div>
    }
  } @else {
    <div class="no-record">
      <p>No Records</p>
    </div>
  }
}